import { Dto } from '@damofire/data-commons';
import { OrganizationInfos } from '@damofire/data-stas';
import { Timestamp } from 'firebase/firestore';
import { Asset, Column, PalletLevel, System2d, Upright } from '../asset/asset.dto';
import { Inspection } from '../inspection/inspection.dto';
import { Issue, IssueMedia } from '../issue/issue.dto';
import { Note } from '../note/note.dto';
import { LayoutTextSegment, WarehouseOutlineSegment } from '../warehouse/warehouse.dto';

export const SNAPSHOT_SCHEMA_VERSION = 1;

export enum SnapshotStatus {
  PENDING = 'PENDING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}

export interface WarehouseStateSnapshotMeta extends OrganizationInfos, Dto<string> {
  inspectionId?: string;
  importId?: string;
  sourceAnalysisImportId?: string;
  // Arrives over HTTP as a JSON string or { _seconds, _nanoseconds }, never a live Firestore
  // Timestamp. Normalize before formatting.
  createdAt?: Timestamp | Date | string;
  createdBy?: string;
  label?: string;
  status?: SnapshotStatus;
  schemaVersion?: number;
  counts?: Record<string, number>;
  bucketPath?: string;
  layoutOnly?: boolean;
}

export interface WarehouseStateSnapshotPayload {
  schemaVersion: number;
  systems: System2d[];
  assets: Asset[];
  /**
   * Filled by the backend from `ww-warehouses/{divisionId}/assets` — the same collection
   * `FirebaseUprightService.list` reads — so these are `Upright` docs. The key name is the
   * HTTP wire contract with `ww-snapshots/:snapshotId/payload`; do not rename it here.
   */
  warehouseAssets: Upright[];
  issues: Issue[];
  /** Each Column embeds its own `palletLevels`; that is what the canvas renders. */
  columns: Column[];
  /** Flattened copy of every Column.palletLevels. Redundant for canvas rendering. */
  palletLevels: PalletLevel[];
  layoutTexts: LayoutTextSegment[];
  outline: WarehouseOutlineSegment[];
  pictures: IssueMedia[];
  /**
   * For `layoutOnly` snapshots the backend ships `issues: []`, `pictures: []` and
   * `reviews: []`. `SystemCanvasDecorator.updateInspection` dereferences `reviews`
   * unguarded, so consumers must normalize it.
   */
  inspection: Inspection;
  notes: Note[];
}
